import { ColumnDef } from '@tanstack/react-table'
import { GetInviteFriendReferredPlayersData } from '@/modules/manage-player/type'
import { format } from 'date-fns'
import { th } from 'date-fns/locale'
import { Link } from 'react-router-dom'
import { Button } from '@/common/ui/button'
import { ChevronRight, ChevronDown } from 'lucide-react'
import { PhoneCell } from '@/common/components/PhoneCell'
import { UsernameCell } from '@/common/components/UsernameCell'

type ReferredPlayerWithExpand = GetInviteFriendReferredPlayersData & {
	hasChildren?: boolean
	isExpanded?: boolean
	depth?: number
}

export const expandableReferredColumns: ColumnDef<ReferredPlayerWithExpand>[] =
	[
		{
			id: 'expand',
			header: '',
			cell: ({ row }) => {
				const hasChildren = row.original.hasChildren ?? false
				const isExpanded = row.original.isExpanded ?? false

				if (!hasChildren) {
					return <div className="w-6" />
				}

				return (
					<div className="flex w-6 items-center justify-center">
						{isExpanded ? (
							<ChevronDown className="h-4 w-4 text-muted-foreground" />
						) : (
							<ChevronRight className="h-4 w-4 text-muted-foreground" />
						)}
					</div>
				)
			},
			size: 40,
		},
		{
			accessorKey: 'username',
			header: 'ชื่อผู้ใช้',
			cell: ({ row }) => (
				<UsernameCell
					username={
						(row.original as Record<string, unknown>).username as string | null
					}
				/>
			),
		},
		{
			accessorKey: 'phone',
			header: 'สมาชิก',
			cell: ({ row }) => (
				<PhoneCell
					playerId={row.original.playerId}
					phone={row.getValue('phone') as string}
				/>
			),
		},
		{
			accessorKey: 'createdAt',
			header: 'วันที่สมัคร',
			cell: ({ row }) =>
				format(new Date(row.original.createdAt || ''), 'PPP HH:mm น.', {
					locale: th,
				}),
		},
		{
			accessorKey: 'totalAllCommissions',
			header: 'ค่าคอมมิชชั่นทั้งหมด',
			cell: ({ row }) => {
				const amount = row.original.totalAllCommissions || 0
				return amount.toLocaleString('th-TH', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				})
			},
		},
		{
			id: 'actions',
			header: 'การดำเนินการ',
			cell: () => {
				return (
					<Button variant="outline" size="sm">
						ดูค่าคอมมิชชั่น
					</Button>
				)
			},
		},
		{
			id: 'detail',
			header: 'รายละเอียด',
			cell: ({ row }) => {
				const playerId = row.original.playerId
				return (
					<Link to={`/operator/get-player-list/player-detail/${playerId}`}>
						<Button variant="default" size="sm">
							ดูรายละเอียด
						</Button>
					</Link>
				)
			},
		},
	]
